export const REMOVE_GET_ICE_CANDIDATE = (version: number[]) => {
  return version[0] >= 2;
};
